module.exports = "<div class=\"type\">\n    <div>\n        {{question_index}}\n        <span class=\"mandatory\" *ngIf=\"is_mandt\">*</span>. {{question_name}}\n    </div>\n    <div>\n        {{question_name_second}}\n    </div>\n    <app-rating [rating]='rating' (ratingClick)='ratingComponetClick($event)' style=\"display:inline-block\"></app-rating>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/rating-type/rating-type.component.html
// module id = ./src/app/questions-type/rating-type/rating-type.component.html
// module chunks = main